import {
  CREATE_APPLICATION,
  EDIT_APPLICATION,
  REGENERATE_APP_KEY,
  RESET_APPLICATION_RESPONSE_MSG,
  SET_CREATE_APPLICATION_STATUS,
  SET_EDIT_APPLICATION_STATUS,
  SET_REGENERATE_APP_KEY_STATUS,
  GET_ACCOUNT_SETTING,
  GET_ACCOUNT_SETTING_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_RESET,
  EDIT_ACCOUNT_SETTING_SUCCESS,
  EDIT_ACCOUNT_SETTING,
  EDIT_ACCOUNT_SETTING_RESET,
  DELETE_APPLICATION,
  SET_DELETE_APPLICATION_STATUS,
  RESET_ACCOUNT_SETTING,
  VERIFY_PHONE_NUMBER,
  VERIFY_OTP,
  SET_OTP_STATUS,
  TOGGLE_TWO_FACTOR_AUTH,
  SET_TWO_FACTOR_AUTH_STATUS,
  RESEND_OTP,
  SET_RESEND_OTP_STATUS,
  RESET_RESEND_OTP_RESPONSE_MSG,
  VERIFY_CURRENT_PASSWORD,
  SET_VERIFY_CURRENT_PASSWORD_STATUS,
  SEND_EMAIL,
  SET_SEND_EMAIL_STATUS,
  UPDATE_CONTACT_DETAILS,
  SET_UPDATE_CONTACT_DETAILS,
  VERIFY_LOGIN_OTP,
  SET_LOGIN_OTP_STATUS,
  VERIFY_EMAIL,
  SET_VERIFY_EMAIL_STATUS,
  SET_RESEND_LOGIN_OTP_STATUS,
  RESEND_LOGIN_OTP
} from "./actionTypes"

const initialState = {
  responseMessage: null,
  responseStatus: null,
  loading: false,
  appKey: "",
  appId: "",
  appName: "",
  regeneratedAppKey: "",
  generateApikeyLoading: "",
  applicationIcon: "",
  getAccountData: {
    responseMessage: null, responseStatus: null, loading: false, data: null
  },
  changePassword: {
    responseMessage: null, responseStatus: null, loading: false,
  },
  editAccountSetting: {
    responseMessage: null, responseStatus: null, loading: false,
  },
  applicationDelLoading: false,
  verifyPhone: {
    loading: false,
    error: false,
  },
  twoFactorAuth: {
    enabled: false,
    loading: false
  },
  resendOtp: {
    loading: false,
    responseMessage: null
  },
  verifyCurrentPswd: {
    loading: false,
    error: false
  },
  sendEmail: {
    loading: false,
    error: false
  },
  updateContact: {
    loading: false,
    error: false
  },
  verifyLoginPhone: {
    loading: false,
    error: false,
  },
  verifyEmail: {
    loading: false,
    error: false
  },
  resendLoginOtp: {
    loading: false,
    error: false
  }



}

const Application = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_APPLICATION:
      state = {
        ...state,
        loading: true
      }
      break
    case EDIT_APPLICATION:
      state = {
        ...state,
        loading: true
      }
      break
    case SET_CREATE_APPLICATION_STATUS:
      state = {
        ...state,
        responseStatus: action.payload?.responseStatus || null,
        responseMessage: action.payload?.responseMessage || null,
        appKey: action.payload?.response?.app_key || "",
        appId: action.payload?.response?.app_id || "",
        loading: false,
        appName: action?.payload?.response?.app_name,
        applicationIcon: action?.payload?.response?.application_icon

      }
      break
    case SET_EDIT_APPLICATION_STATUS:
      state = {
        ...state,
        responseStatus: action.payload?.responseStatus || null,
        responseMessage: action.payload?.responseMessage || null,
        app_key: "",
        loading: false,
        appId: action.payload?.response?.app_id || "",
        applicationIcon: action?.payload?.response?.application_icon,

      }
      break
    case RESET_APPLICATION_RESPONSE_MSG:
      state = {
        ...state,
        responseStatus: null,
        responseMessage: null,
        app_key: "",
        regeneratedAppKey: action.payload?.from === "regeneratedAppKey" ? "" : state.regeneratedAppKey,
        loading: false,
        applicationIcon: action.payload?.from === "applicationIcon" ? "" : state.applicationIcon,

      }
      break
    case REGENERATE_APP_KEY:
      state = {
        ...state,
        generateApikeyLoading: true
      }
      break
    case SET_REGENERATE_APP_KEY_STATUS:
      state = {
        ...state,
        responseStatus: action.payload?.responseStatus || null,
        responseMessage: action.payload?.responseMessage || null,
        regeneratedAppKey: action.payload?.response?.app_key || null,
        generateApikeyLoading: false
      }
      break
    case GET_ACCOUNT_SETTING:
      state = {
        ...state,
        getAccountData: {
          ...state.getAccountData,
          loading: true,
        }
      }
      break

    case GET_ACCOUNT_SETTING_SUCCESS:
      state = {
        ...state,
        getAccountData: {
          responseMessage: action.payload.responseMessage,
          responseStatus: action.payload.responseStatus,
          loading: false,
          data: {
            ...state.getAccountData.data,
            ...action.payload.response
          }
        }
      }
      break
    case CHANGE_PASSWORD:
      state = {
        ...state,
        changePassword: {
          responseMessage: null, responseStatus: null, loading: true,
        }
      }
      break
    case CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changePassword: {
          responseMessage: action.payload.responseMessage || '',
          responseStatus: action.payload.responseStatus,
          loading: false,
        }
      }
      break
    case CHANGE_PASSWORD_RESET:
      state = {
        ...state,
        changePassword: {
          responseMessage: null, responseStatus: null, loading: false,
        }
      }
      break

    case EDIT_ACCOUNT_SETTING:
      state = {
        ...state,
        editAccountSetting: {
          responseMessage: null, responseStatus: null, loading: true,
        }
      }
      break

    case EDIT_ACCOUNT_SETTING_SUCCESS:
      state = {
        ...state,
        editAccountSetting: {
          responseMessage: action.payload.responseMessage || '',
          responseStatus: action.payload.responseStatus,
          loading: false,
        },
        getAccountData: {
          ...state.getAccountData,
          data: action.payload.response && action.payload?.responseCode ? action.payload.response : state.getAccountData.data
        }
      }
      break
    case EDIT_ACCOUNT_SETTING_RESET:
      state = {
        ...state,
        editAccountSetting: {
          responseMessage: null, responseStatus: null, loading: false,
        }
      }
      break
    case DELETE_APPLICATION:
      state = {
        ...state,
        applicationDelLoading: true
      }
      break
    case SET_DELETE_APPLICATION_STATUS:
      state = {
        ...state,
        responseStatus: action.payload?.responseStatus || null,
        responseMessage: action.payload?.responseMessage || null,
        app_key: "",
        applicationDelLoading: false

      }
      break
    case RESET_ACCOUNT_SETTING:
      state = {
        ...state,
        getAccountData: {
          responseMessage: null,
          responseStatus: null,
          loading: false,
          data: null
        }
      }
      break
    case VERIFY_OTP:
      state = {
        ...state,
        verifyPhone: {
          loading: true
        }
      }
      break
    case VERIFY_EMAIL:
      state = {
        ...state,
        verifyEmail: {
          loading: true
        }
      }
      break
    case SET_VERIFY_EMAIL_STATUS:
      state = {
        ...state,
        verifyEmail: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        }
      }
      break
    case VERIFY_LOGIN_OTP:
      state = {
        ...state,
        verifyLoginPhone: {
          loading: true,
        }
      }
      break
    case SET_LOGIN_OTP_STATUS:
      state = {
        ...state,
        verifyLoginPhone: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        }
      }
      break
    case SET_OTP_STATUS:
      state = {
        ...state,
        verifyPhone: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        },
        getAccountData: {
          ...state.getAccountData,
          data: {
            ...state.getAccountData.data,
            is_phone_verified: action.payload.from === "phone" || action.payload.from === "two-factor-auth" ? action.payload.responseCode ? true : state.getAccountData.data.is_phone_verified : state.getAccountData.data.is_phone_verified
          }
        }
      }
      break
    case TOGGLE_TWO_FACTOR_AUTH:
      state = {
        ...state,
        twoFactorAuth: {
          loading: true
        }
      }
      break
    case SET_TWO_FACTOR_AUTH_STATUS:
      state = {
        ...state,
        twoFactorAuth: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        },
        getAccountData: {
          ...state.getAccountData,
          data: {
            ...state.getAccountData.data,
            two_factor: action.payload.responseCode ? action.payload.enabled : state.getAccountData.data.two_factor
          }
        }
      }
      break
    case RESEND_OTP:
      state = {
        ...state,
        resendOtp: {
          loading: true,
          from: action.payload.from
        },
        verifyPhone: {
          loading: false,
          error: null,
        },
      }
      break
    case RESEND_LOGIN_OTP:
      state = {
        ...state,
        resendLoginOtp: {
          loading: true,
        },
      }
      break
    case SET_RESEND_LOGIN_OTP_STATUS:
      state = {
        ...state,
        resendLoginOtp: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        },


      }

      break
    case SET_RESEND_OTP_STATUS:
      state = {
        ...state,
        resendOtp: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        },


      }

      break
    case RESET_RESEND_OTP_RESPONSE_MSG:
      state = {
        ...state,
        verifyPhone: {
          loading: false,
          error: false,
        },
        twoFactorAuth: {
          enabled: false,
          loading: false
        },
        resendOtp: {
          loading: false,
          responseMessage: null
        },
        verifyCurrentPswd: {
          loading: false,
          error: false
        },
        sendEmail: {
          loading: false,
          error: false
        },
        updateContact: {
          loading: false,
          error: false
        },
        verifyLoginPhone: {
          loading: false,
          error: false,
        },
        verifyEmail: {
          loading: false,
          error: false
        },
        resendLoginOtp: {
          loading: false,
          error: false
        }
      }

      break
    case VERIFY_CURRENT_PASSWORD:
      state = {
        ...state,
        verifyCurrentPswd: {
          loading: true,
        }
      }

      break
    case SET_VERIFY_CURRENT_PASSWORD_STATUS:
      state = {
        ...state,
        verifyCurrentPswd: {
          loading: false,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        }
      }

      break
    case SEND_EMAIL:
      state = {
        ...state,
        sendEmail: {
          loading: true,
        },
        verifyPhone: {
          loading: false,
          error: null,
        },
      }

      break
    case SET_SEND_EMAIL_STATUS:
      state = {
        ...state,
        sendEmail: {
          loading: true,
          error: action.payload.responseCode ? false : true,
          ...action.payload
        }
      }

      break
    case UPDATE_CONTACT_DETAILS:
      state = {
        ...state,
        updateContact: {
          loading: true,

        }
      }
    case SET_UPDATE_CONTACT_DETAILS:
      state = {
        ...state,
        updateContact: {
          loading: true,
          error: action.payload.responseCode ? false : true,
          ...action.payload

        },
        getAccountData: {
          ...state.getAccountData,
          data: {
            ...state.getAccountData.data,
            cid: action.payload.from === "phone" ? action.payload.cid : state.getAccountData.data.cid,
            cmp_phone_code: action.payload.from === "phone" ? action.payload.cmp_phone_code : state.getAccountData.data.cmp_phone_code,
            cmp_email: action.payload.from === "email" ? action.payload.cmp_email : state.getAccountData.data.cmp_email,
            phone: action.payload.from === "phone" ? action.payload.cmp_phone : state.getAccountData.data.phone



          }
        }
      }

      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default Application
